import { useContext, useEffect, useState } from 'react';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';
import getFBRQuery from '../queries/fbr/getFBRQuery';
import { ProductFragments, queryRequiresStoreId } from '../queries/product/getProductQuery';
import { getProductQuery } from '../queries';
import DataProviderContext from '../react/DataProviderContext';
import { useQuery } from './useQuery';

const useFBR = ({
  itemId, storeId, productDomains = [], ssr = true, skip = false,
}) => {
  const dpContext = useContext(DataProviderContext);
  const ctx = useContext(ExperienceContext);

  const opts = {
    ssr,
    skip,
    errorPolicy: 'all',
    variables: {
      itemId
    }
  };

  if (storeId) {
    opts.variables.storeId = storeId;
  }
  const Query = getFBRQuery({ productDomains });
  const resp = useQuery(Query, opts);
  const fbrItems = resp?.data?.fbr?.fbrItems;
  if (dpContext.productCache && resp.fbrItems) {
    const { products } = fbrItems;
    (products || []).forEach(({ product }) => {
      dpContext.productCache.addProduct({
        product,
        storeId: resp.variables.storeId || '8119'
      });
    });
  }
  return resp;
};

export default useFBR;
